import dayjs from 'dayjs'
import { Message } from 'element-ui'
import { RestrictMallCode, RestrictType } from '@/enum/localEnum'

// 商品编号-new-全局匹配-查找所有
export const goodsNoNewRegGlobal = /[a-z][a-z0-9]{4,6}/gi
// 商品编号-old-全局匹配-查找所有
export const goodsNoOldRegGlobal = /[a-z]{1,6}\d{5,11}/gi
export const emailReg = /\b([\w._%+-]+@[\da-z.-]+\.[a-z.]{2,6})\b/gi
export const linkReg = /\b((https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*(\?[\w%&=-]*)?(\w+)*)\b/gi
// 商品编号-old-边界匹配-查找所有
export const goodsNoOldReg_EdgeAll = /\b[a-z]{1,6}\d{5,11}\b/gi
// 商品编号-new-边界匹配-查找所有
export const goodsNoNewReg_EdgeAll = /\b[a-z][a-z0-9]{4,6}\b/gi
/**
 * @param path
 * @returns {boolean}
 */
export function isExternal(path) {
	return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * window.open(url)打开链接被浏览器拦截解决方案
 * @param url
 */
export function addBlankPath(url) {
	const a = document.createElement('a')
	a.href = url // 窗口的链接
	a.target = '_blank'
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
}

/**
 * 第三方客服
 * @param url
 * @param userinfo
 */
export function thirdPartyServiceInfo(url, userinfo) {
	// let info = `${url}&visitor_id=${userinfo.id}&nickname=${userinfo.nickname}`;
	// if(userinfo.headImage) info += `&avatar=${userinfo.headImage}`
	// addBlankPath(info)
	addBlankPath(url)
}
/**
 * 添加class
 * @param ele 元素
 * @param cls class名
 */
export function addClass(ele, cls) {
	if (!hasClass(ele, cls)) ele.className += ' ' + cls
}
/**
 * 判断是否存在某个Class
 * @param ele 元素
 * @param cls class名
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
	return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
/**
 * 删除Class
 * @param ele 元素
 * @param cls class名
 */
export function removeClass(ele, cls) {
	if (hasClass(ele, cls)) {
		const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
		ele.className = ele.className.replace(reg, ' ')
	}
}
export function parseTime(time, cFormat) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if (typeof time === 'string') {
			if (/^[0-9]+$/.test(time)) {
				// support "1548221490638"
				time = parseInt(time)
			} else {
				const reg = /-/gm
				// support safari
				// https://stackoverflow.com/questions/4310953/invalid-date-in-safari
				time = time.replace(new RegExp(reg), '/')
			}
		}

		if (typeof time === 'number' && time.toString().length === 10) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
	return timeStr
}

/**
 * @param str
 * @returns {boolean}
 */
export function validUsername(str) {
	return str.includes(str.trim())
}

export function isPc() {
	const userAgentInfo = navigator.userAgent
	const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
	let flag = true
	for (let v = 0; v < Agents.length; v++) {
		if (userAgentInfo.indexOf(Agents[v]) > 0) {
			flag = false
			break
		}
	}
	return flag
}

export function timeFix() {
	const time = new Date()
	const hour = time.getHours()
	return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function toMoney(num) {
	num = num.toFixed(2)
	num = parseFloat(num)
	num = num.toLocaleString()
	if (!num.includes('.')) {
		num += '.00'
	}
	return num
}

// 随机生成文件名
export function randomString(len) {
	len = len || 32
	const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
	const maxPos = chars.length
	let pwd = ''
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return pwd
}

// 删除包含的固定字段
export function deleteFixedEnName(data) {
	if (!data) return
	const fixedEnName = [
		'id',
		'goodsNo',
		'sellRange',
		'sellType',
		'accountSource',
		'gameId',
		'goodsCatalogueId',
		'accountSource',
		'title',
		'goodsImg',
		'description',
		'simpleMessage',
		'price',
		'transactionPrice',
		'transactionTime',
		'outGoodsNo',
		'heat',
		'tempHeat',
		'sortTime',
		'shotType',
		'shotRemark',
		'linkPhone',
		'linkQq',
		'compensation',
		'isTop',
		'merchantMark',
		'isDel',
		'status',
		'onStandTime',
		'oneselfDownStandTime',
		'forceDownStandTime',
		'sellerId',
		'searchField',
		'updateTime',
		'createTime',
		'remark',
		'verifyTime',
		'forceDownStandRemark',
		'detailsImages',
		'gameAccount',
		'gameSecret'
	]
	const arr = []
	data.forEach(item => {
		if (!fixedEnName.includes(item.mappingField)) {
			return arr.push(item)
		}
	})
	return arr
}
/**
 * 防抖
 * @param {*} fn
 * @param {*} delay
 * @param {*} immediate
 * @returns
 */
export function debounce(fn, delay = 300, immediate = true) {
	let timer
	return function () {
		const context = this
		const args = arguments
		if (immediate && !timer) {
			fn.apply(context, args)
		}
		clearTimeout(timer)
		timer = setTimeout(function () {
			if (!immediate) {
				fn.apply(context, args)
			}
			timer = null
		}, delay)
	}
}
export function removeCurArray(arr, value) {
	let i = arr.length
	while (i--) {
		if (arr[i] === value) {
			return i
		}
	}
	return false
}
export function toDom(toEl, n) {
	// let bridge = toEl;
	// const body = document.body;
	// let height = 0;
	// do {
	//   height += bridge.offsetTop;
	//   bridge = bridge.offsetParent;
	// } while (bridge !== body);
	// window.scrollTo({
	//   top: height - n,
	//   behavior: 'smooth',
	// });
}
/**
 * 根据配置类型显示内容展示
 */
export function mappingFieldToStr(detailsData, item) {
	const label = 'LABEL' // 标签
	const single = 'SINGLE' // 单选
	const config = 'CONFIG' // 区服配置
    const other = 'OTHER' // 其他
	if (item.fieldType === label || item.fieldType === single || item.fieldType === config ) {
		// 如果是布尔值
		if (typeof detailsData[item.mappingField] === 'boolean') {
			if (detailsData[item.mappingField]) {
				return '是'
			}
			return '不是'
		}
		return detailsData[item.mappingField + 'Name']
	}
    if(item.fieldType === other){
        if(typeof detailsData[item.mappingField] === 'boolean'){
            if(detailsData[item.mappingField]){
                return '是'
            }
            return '不是'
        }
    }
	if (Array.isArray(detailsData[item.mappingField])) {
		return detailsData[item.mappingField].toString()
	}

	return detailsData[item.mappingField]
}

/**
 * 最近浏览
 * @param item 游戏列表
 */
export const newViewEnum = 99 // 游戏栏目"最近浏览"的ID，是为了选中效果
export function setHistoryList(item, historyName = 'HistoryList') {
	const _arr = JSON.parse(window.localStorage.getItem(historyName)) || []
	if (_arr.length) {
		// let newHistoryList = JSON.parse(window.localStorage.getItem(historyName));
		// let newArr = HistoryList.concat(newHistoryList);
		_arr.forEach((vo, key) => {
			if (vo.id === item.id) {
				_arr.splice(key, 1)
			}
		})
	}
	_arr.unshift(item)
	// 账号和id显示个数
	const ACCOUNT = 6
	const AccountViewNum = 8 // 显示个数
	const accountList = _arr.filter(item => item.goodsCatalogueId === ACCOUNT)
	if (accountList.length > AccountViewNum) {
		accountList.pop()
	}
	const ID = 7
	const IdViewNum = 8 // 显示个数
	const idList = _arr.filter(item => item.goodsCatalogueId === ID)
	if (idList.length > IdViewNum) {
		idList.pop()
	}
	const curArr = accountList.concat(idList)
	window.localStorage.setItem(historyName, JSON.stringify(curArr))
}
/**
 * downFile文件下载
 * @param url 下载链接
 * @param saveName 保存名字
 */
export function downFile(url, saveName) {
	if (typeof url === 'object' && url instanceof Blob) {
		url = URL.createObjectURL(url) // 创建blob地址
	}
	const aLink = document.createElement('a')
	aLink.href = url
	aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
	let event
	// if (window.MouseEvent) {
	//   event = new MouseEvent('click');
	// } else {
	//   event = document.createEvent('MouseEvents');
	//   event.initMouseEvent(
	//     'click',
	//     true,
	//     false,
	//     window,
	//     0,
	//     0,
	//     0,
	//     0,
	//     0,
	//     false,
	//     false,
	//     false,
	//     false,
	//     0,
	//     null
	//   );
	// }
	aLink.click()
	// aLink.dispatchEvent(event);
}
/**
 * loadScript
 * @param type 类型
 * @param url 资源地址
 * @returns {Promise}
 */
export function loadScript(type = 'js', url) {
	let flag = false
	return new Promise(resolve => {
		const head = document.getElementsByTagName('head')[0]
		head.children.forEach(ele => {
			if ((ele.src || '').includes(url)) {
				flag = true
				resolve()
			}
		})
		if (flag) return
		let script
		switch (type) {
			case 'js':
				script = document.createElement('script')
				script.type = 'text/javascript'
				script.src = url
				break
			default:
				script = document.createElement('link')
				script.rel = 'stylesheet'
				script.type = 'text/css'
				script.href = url
		}
		head.appendChild(script)
		script.onload = function () {
			resolve()
		}
	})
}

/**
 * 加载 canonical
 */
export function loadLink(url) {
	let flag = false
	return new Promise(resolve => {
		const head = document.getElementsByTagName('head')[0]
		head.children.forEach(ele => {
			if ((ele.src || '').includes(url)) {
				flag = true
				resolve()
			}
		})
		if (flag) return
		let _script = {}
		_script = document.createElement('link')
		_script.rel = 'canonical'
		_script.href = url
		head.appendChild(_script)
		_script.onload = function () {
			resolve()
		}
	})
}

/**
 * 睡眠
 * @param time
 */
export function sleep(time) {
	return new Promise(resolve => {
		const timer = setTimeout(() => {
			clearTimeout(timer)
			resolve()
		}, time)
	})
}


/**
 * 检查用户是否被限制
 * @param {Array} restrictMall 限制列表
 * @param {string} code 限制码
 */
export function checkRestrictMall (restrictMall = [], code = '' , type=1) {
    let isRestrict = false
    // 提示词字典
    const tipsDict = {
        [RestrictMallCode.ALL_BUY]:'很抱歉，您的账户暂不支持交易',
        [RestrictMallCode.AGENCY_BUY]: '很抱歉，您的账户暂不支持交易',
        [RestrictMallCode.BARGAIN_CREATE]: '很抱歉，您的账户暂不支持砍价',
        [RestrictMallCode.GOODS_SELL]: type===1?'很抱歉，您的账户暂不支持交易':'当前卖家被限制出售账号，暂时无法进行交易'
    }
    const restrictMallItem = restrictMall.find(item => item.restrictionsCode === code)
    if (restrictMallItem) {
        const { endTime, type } = restrictMallItem
        // 永久
        if (type === RestrictType.PERPETUAL) {
            isRestrict = true
            // 临时限制
        } else if (type === RestrictType.DURATION) {
            // 判断时间是否过期
            if (dayjs(endTime).isAfter(dayjs())) {
                isRestrict = true
            }
        }
    }

    isRestrict && Message.warning(tipsDict[code])

    return isRestrict
}
